import { FC } from "react";
import cn from "classnames";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { getItemPath } from "src/utils/getItemPath";
import { combineSlugId } from "src/utils/combineSlugId";
import { getImageUrl } from "src/utils/getImageUrl";
import { PATHNAMES } from "src/constants/routes";
import { IClone } from "src/@types/clones";
import { Link } from "../Link";
import { CardPrice } from "../Card/CardPrice";
import { TextEditorView } from "../TextEditor/TextEditorView";

interface Props {
  className?: string;
  clone?: IClone;
}

export const PopularCloneCard: FC<Props> = ({ className, clone }) => {
  const {
    id,
    clone_cost,
    slug,
    describe_product,
    main_photo,
    host,
    company_name,
  } = clone || {};

  const countryIcon = host?.location?.country?.icon;
  const countryTitle = host?.location?.country?.title;

  const combineSlug = combineSlugId(slug, id);

  return (
    <div
      className={cn(
        "grid xs:grid-cols-2 bg-purple-lighter rounded-20 md:h-52 w-full",
        className
      )}
    >
      <div className="flex h-48 xs:h-40 sm:h-52 lg:max-w-76 w-full">
        <Link
          className="flex rounded-20 overflow-hidden w-full"
          href={getItemPath(PATHNAMES.CLONE_ITEM, {
            slug: combineSlug,
          })}
        >
          <LazyLoadImage
            className="w-full h-full object-cover object-center rounded-20 hover:scale-125 !transition-all !duration-200"
            src={getImageUrl(main_photo)}
            alt={company_name}
            effect="blur"
            wrapperProps={{
              style: { width: "100%", height: "100%" },
            }}
          />
        </Link>
      </div>

      <div className="flex flex-col justify-between gap-3 p-3 xl:p-5">
        <TextEditorView viewType="text" className="line-clamp-4">
          {describe_product}
        </TextEditorView>

        <div className="flex justify-between items-center">
          <img
            src={getImageUrl(countryIcon)}
            alt={countryTitle}
            title={countryTitle}
          />
          <CardPrice price={clone_cost} />
        </div>
      </div>
    </div>
  );
};
